<template>
	<label class="nut-checkbox" :class="{ 'is-checked': isActive }">
		<span
			@click="checkedChange"
			class="checkbox-inner"
			:style="checkSize"
		></span>
		<span class="checkbox-label">{{ label }}</span>
		<input type="checkbox" :name="name" :checked="isActive" />
	</label>
</template>
<script>
export default {
	data() {
		return {
			isActive: false,
		}
	},
	props: {
		label: {
			type: String,
			default: () => '',
		},
		isChecked: {
			type: Boolean,
			default: () => false,
		},
		size: {
			type: [Number, String],
			default: () => 14,
		},
		name: {
			type: String,
			default: () => '',
		},
	},
	computed: {
		checkSize() {
			let size = Number(this.size) || 14
			return `width: ${size}px;height: ${size}px; top: ${8 - size / 2}px`
		},
	},
	created() {
		this.isActive = !!this.isChecked
	},
	methods: {
		checkedChange() {
			this.isActive = !this.isActive
			this.$emit('on-change', this.isActive)
		},
	},
}
</script>

<style lang="scss" scoped>
.nut-checkbox {
	user-select: none;
	input[type='checkbox'] {
		display: none;
	}
}
.nut-checkbox.is-checked {
	.checkbox-inner {
		background-color: #409eff;
		border-color: #409eff;
	}
}
.checkbox-label {
	display: inline-block;
	padding-left: 10px;
	line-height: 20px;
	font-size: 14px;
}
.checkbox-inner {
	display: inline-block;
	position: relative;
	border: 1px solid #dcdfe6;
	border-radius: 2px;
	background-color: #fff;
	z-index: 1;
	transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
		background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
</style>
